import { render } from "./header-field-editor.vue?vue&type=template&id=4a0600d2"
import script from "./header-field-editor.vue?vue&type=script&lang=js"
export * from "./header-field-editor.vue?vue&type=script&lang=js"

import "./header-field-editor.vue?vue&type=style&index=0&id=4a0600d2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__